import { render, staticRenderFns } from "./FeedLikers.vue?vue&type=template&id=84f6577e&scoped=true&"
import script from "./FeedLikers.vue?vue&type=script&lang=ts&"
export * from "./FeedLikers.vue?vue&type=script&lang=ts&"
import style0 from "./FeedLikers.vue?vue&type=style&index=0&id=84f6577e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f6577e",
  null
  
)

export default component.exports